import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse

} from '@angular/common/http';
import { Observable,throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { HelperService } from '../services/helper.service';

@Injectable()
export class UserAccessInterceptor implements HttpInterceptor {
 private isSessionExpired = false;
    constructor(
    private router: Router,
    private localStorageService: LocalStorageService,
    private helperService: HelperService,
    
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      const authRequest = request.clone({
        headers: request.headers.set('Source-Url', `${window.location.href}`)
      });
      return next.handle(authRequest).pipe(
      catchError((error: HttpErrorResponse ) => {
        if (error.status === 401 && !this.isSessionExpired) {
         this.isSessionExpired = true; // Set flag so this block runs only once

          // Clear token and user data
          this.localStorageService.clear();
          this.helperService.showErrorToast("Your session has expired. Please log in again.");
          this.router.navigate(['/login'])
         
        }
        return throwError(() => error);
      })
    );
  }
}
